<template>
  <div :style="{position: $isMobile() ? 'relative': '', top: $isMobile() ? '-34px' : ''}">
    <div
      class="text-center text-base relative text-center"
      style="left: 0; right: 0; top: 140px"
      :style="{
        color: !nightMode ? '#fff' : '#000',
        top: !$isMobile() ? '210px' : '170px',
      }"
    >
      <div class="w-1/4 mx-auto relative" :style="{ top: $isMobile() ? '15px': ''}">
        {{ graph.name }}
      </div>
      <v-popover
        v-if="$isMobile()"
        offset="16"
        style="position: relative; top:115px"
      >
        <button class="tooltip-target b3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-info-circle"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            />
          </svg>
        </button>
        <template slot="popover">
          <div>
            <div style="margin: auto; display: inline-block">
              <img
                width="100%"
                :src="
                  require('@/assets/' +
                    $t('dashboard_sensor_' + graph.influxId) +
                    '.jpg')
                "
                alt="ha5tClD.jpg"
              />
            </div>
          </div>
        </template>
      </v-popover>
      <v-popover
        v-else
        offset="20"
        trigger="hover"
        style="position: relative; top: 90px"
      >
        <button class="tooltip-target b3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-info-circle"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            />
          </svg>
        </button>

        <template slot="popover">
          <div style="width: 50vh; margin: auto">
            <img
              width="100%"
              :src="
                require('@/assets/' +
                  $t('dashboard_sensor_' + graph.influxId) +
                  '.jpg')
              "
              alt="ha5tClD.jpg"
            />
          </div>
        </template>
      </v-popover>
      <div>
        <div>
          <FacebookLoader
              v-if="hideLoader"
              :color="this.nightMode === true ? '#000000' : '#ffffff'"
              :size="30"
              class="my-1"
              :style="{
                position: $isMobile() ? 'relative': 'absolute',
                top: $isMobile() ? '' : '25%',
                left: $isMobile() ? '' : '48.8%'
                }"
            />
        </div>
        <div
          class="relative"
          style="left: 0; right: 0; top: 0px"
          :style="{ color: !nightMode ? '#fff' : '#000', top: $isMobile()? '-10px': '' }"
        >
          ___________
        </div>
        <div
          class="relative text-sm"
          style="left: 0.5%; right: 0; top: 22px"
          :style="{
            color: !nightMode ? '#fff' : '#000',
            left: '0px',
            top: '0px',
          }"
        >
          {{ formatNames(graph.influxId) }}
        </div>
      </div>
    </div>
    <vue-gauge
      :style="'--svg-show:' + 'hidden'"
      :class="{ 'custom-gauge-dark': !nightMode, 'custom-gauge': nightMode }"
      :refid="`AQI`"
      :options="{
        needleValue: 0,
        needleColor: !nightMode ? 'white' : 'black',
        arcDelimiters: getValueSensor(graph.influxId),
        arcPadding: 10,
        rangeLabel: [
          `${getMinSensorValue(graph.influxId)}`,
          `${getMaxSensorValue(graph.influxId)}`,
        ],
        arcColors: getColorSensor(graph),
        centralLabel: '0,00',
        chartWidth: !$isMobile() ? 370 : 270,
      }"
    >
    </vue-gauge>
  </div>
</template>

<script>
  /**
 * Componente de gráfico de donut del AQI de DASHBOARD.
 * --------------------------------------------
 *
 * Este componente dibuja un gráfico a partir de la data recibida para el AQI.
 * Tiene un diseño donde muestra el nombre completo, el nombre técnico y la información sobre los límites de colores(pop-up con imagen)
 *
 */
module.exports = {
  props: ["donut", "nightMode","hideLoader"],
  data() {
    return {
      graph: this.donut,
      limits: [
        {
          name: "AQI",
          min: 0,
          max: 200,
          limit: [
            { min: 0, max: 20, color: "#20C4BA" },
            { min: 20, max: 40, color: "#5FCC56" },
            { min: 40, max: 60, color: "#EFC045" },
            { min: 60, max: 80, color: "#FC5255" },
            { min: 80, max: 100, color: "#940634" },
            { min: 100, max: 200, color: "#7C267E" }
          ],
        }
      ]
    };
  },
  methods: {
        /**
     * Obtiene el valor central del arco a partir de el valor pasado por parámetro y el sensor.
     * @param value
     */
    returnCentralLabel(value) {
        return `${value}`;
    },
    /**
     * Obtiene el valor a donde tiene que apuntar la flecha del arco a partir de el valor pasado por parámetro y el sensor.
     * @param name
     */
    getValueSensor(name) {
      var arrBySensor = [];
      this.limits.forEach(element => {
        if (name === element.name) {
          
            var maxVal = element.max;
            element.limit.forEach(element => {
              arrBySensor.push(
                this.formatLimitsValue(element.max, maxVal) === 100
                  ? 99.99
                  : this.formatLimitsValue(element.max, maxVal)
              );
            });
        }
      });
      return arrBySensor;
    },
    /**
     * Obtiene el array de colores para cada arco según el sensor pasado por parámetro
     * @param sensor
     */
    getColorSensor(sensor) {
      var colorSensor = [];
      this.limits.forEach(element => {
        if (sensor.influxId === element.name) {
          element.limit.forEach(element => {
            colorSensor.push(element.color);
          });
        }
      });
      return colorSensor;
    },
    /**
     * Retorna el color actual calculado a partir de el valor del sensor
     * pintará el label central y la flecha
     * @param sensor
     */
    getCurrentColor(sensor) {
      var currentColor = "#fff";
      var currentValue = this.returnCentralLabel(
        sensor.sensorData[0][1].toFixed(2),
        sensor.influxId
      );

      this.limits.forEach(element => {
        if (sensor.influxId === element.name) {
          element.limit.forEach(limit => {
            if (currentValue >= limit.min && currentValue < limit.max) {
              currentColor = limit.color;
            }
          });
        }
      });
      return currentColor;
    },
    /**
     * Retorna el valor máximo o mínimo de cada sensor para calcular(no es para rellenar los labels delimitadores del arco de los lados)
     * @param name
     */
    getMaxSensorValue(name) {
      var maxValue;
      this.limits.forEach(element => {
        if (name === element.name) {
          maxValue = element.max;
        }
      });
      return maxValue;
    },
    /**
     * Retorna el valor máximo o mínimo de cada sensor para calcular(no es para rellenar los labels delimitadores del arco de los lados)
     * @param name
     */
    getMinSensorValue(name) {
      var minValue;
      this.limits.forEach(element => {
        if (name === element.name) {
          minValue = element.min;
        }
      });
      return minValue;
    },
        /**
     * redondea el valor del límite máximo ya que no puede llegar a 100 ni a 0.
     * @param elMax
     * @param maxVal
     */
    formatLimitsValue(elMax, maxVal) {
      return elMax !== 0 ? (elMax * 100) / maxVal : 0.00001;
    },
        /**
     * Retorna el nombre completo(descripción) de los sensores pasando como parámetro el nombre
     * @param graph
     */
    formatNames(name) {
      if(name === 'AQI') return this.$i18n.t("dashboard_s_aqi");
    },
  },
  watch: {
    /**
     * Detecta sí ha habido un cambio en el modo oscuro para recargar la app
     */
    nightMode: function() {
      window.location.reload();
    }
  }
};
</script>
<style>

svg > path:nth-last-child(5) {
  visibility: var(--svg-show);
}
svg > text:nth-last-child(1) {
  visibility: var(--svg-show);
}
svg > text:nth-last-child(1) {
  fill: var(--svg-fill);
  -webkit-transform: translate(0, 5%);
  -ms-transform: translate(0, 5%);
  transform: translate(0, 5%);
}
</style>